import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import PinOptionDataTableWithSentimentData from './PinOptionDataTableWithSentimentData';
import MapLayerDataTableWithSentimentData from './MapLayerDataTableWithSentimentData';
import PinOptionDataTable from './PinOptionDataTable.js';
import MapLayerDataTable from './MapLayerDataTable';
import OverAllTable from './OverAllTable';
import OverAllTableWithSentimentData from './OverAllTableWithSentimentData';

const PinDropDataTables = (props) => {
  const {
    metadata,
    inputs,
    mapLayers,
    pinOptionsSentimentCounts,
    mapLayersSentimentCounts,
    pinOptionsCommentStatistic,
    mapLayersCommentStatistic,
    overAllCommentStatistic,
    overAllSentimentCounts,
  } = props;

  const renderContent = () => {
    const allowCommentInInputs = inputs.some((input) => get(input, 'metadata.allowComment', false));
    const singlePinAndNoMapLayers = inputs.length === 1 && mapLayers.length === 0;

    if (singlePinAndNoMapLayers) {
      if (!allowCommentInInputs) {
        return <OverAllTable overAllSentimentCounts={overAllSentimentCounts} />;
      }

      return (
        <OverAllTableWithSentimentData
          overAllSentimentCounts={overAllSentimentCounts}
          overAllCommentStatistic={overAllCommentStatistic}
        />
      );
    }

    // if one of inputs has enabled allowComment, show tables with sentiment bars
    if (allowCommentInInputs) {
      return (
        <>
          <div>
            <PinOptionDataTableWithSentimentData
              inputs={inputs}
              counts={pinOptionsSentimentCounts}
              stats={pinOptionsCommentStatistic}
            />
          </div>
          {mapLayersSentimentCounts && mapLayersCommentStatistic && (
            <div>
              <MapLayerDataTableWithSentimentData
                restrictPinsInPolygons={get(metadata, 'restrictPinsInPolygons', false)}
                counts={mapLayersSentimentCounts}
                stats={mapLayersCommentStatistic}
              />
            </div>
          )}
        </>
      );
    }

    return (
      <>
        <div>
          <PinOptionDataTable counts={pinOptionsSentimentCounts} />
        </div>
        {mapLayersSentimentCounts && (
          <div>
            <MapLayerDataTable
              restrictPinsInPolygons={get(metadata, 'restrictPinsInPolygons', false)}
              counts={mapLayersSentimentCounts}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <div className={'pin-drop-data-tables'}>
      <h4 style={{ fontWeight: 600 }}>Results</h4>
      {renderContent()}
    </div>
  );
};

PinDropDataTables.propTypes = {
  metadata: PropTypes.shape({
    restrictPinsInPolygons: PropTypes.bool,
  }).isRequired,
  inputs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mapLayers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pinOptionsSentimentCounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pinOptionsCommentStatistic: PropTypes.shape({}).isRequired,
  mapLayersSentimentCounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mapLayersCommentStatistic: PropTypes.shape({}).isRequired,
  overAllCommentStatistic: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  overAllSentimentCounts: PropTypes.shape({}).isRequired,
};

export default PinDropDataTables;
